import {DestroyRef, Directive, inject, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {Subscription} from 'rxjs';

type ViewMatch = 'vertical' | 'horizontal';

@Directive({
  selector: '[lxViewport]',
  standalone: true,
})
export class LxViewportDirective implements OnInit, OnDestroy {
  private bo = inject(BreakpointObserver);
  private tpl = inject(TemplateRef<any>);
  private vcr = inject(ViewContainerRef);
  private destroyRef = inject(DestroyRef);

  private mode: ViewMatch = 'horizontal';
  private hasView = false;
  private subscription?: Subscription;

  @Input('lxViewport') set kbViewport(mode: ViewMatch) {
    this.mode = mode;
    if (this.subscription) {
      this.checkVisibility();
    }
  }

  ngOnInit() {
    this.subscription = this.bo.observe([Breakpoints.HandsetPortrait]).subscribe(state => {
      this.checkVisibility();
    });

    const resizeHandler = () => {
      this.checkVisibility();
    };
    window.addEventListener('resize', resizeHandler);

    this.destroyRef.onDestroy(() => {
      this.subscription?.unsubscribe();
      window.removeEventListener('resize', resizeHandler);
    });
  }

  private checkVisibility() {
    const isVertical = this.bo.isMatched(Breakpoints.HandsetPortrait);
    const shouldShow = this.mode === 'vertical' ? isVertical : !isVertical;

    if (shouldShow && !this.hasView) {
      this.vcr.clear();
      this.vcr.createEmbeddedView(this.tpl);
      this.hasView = true;
    } else if (!shouldShow && this.hasView) {
      this.vcr.clear();
      this.hasView = false;
    }
  }

  ngOnDestroy() {}
}
